export const api = {
    NAME: "taskweb",
    // API_URL: "https://test.5xwin.in/",
    // API_URL: "http://54.95.127.16:4895/",
    // API_URL: "http://192.168.1.13:4895/",
    API_URL: "https://api.kmaobharat.com/",
  };